import React from "react";
import * as Yup from "yup";
import { Link, useOutletContext } from "react-router-dom";
import { OutletContextType } from "../../types/GlobalType";
import { useState } from "react";
import { studentControler } from "../../_api/controllers/student.controller.ts";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  classeController,
  promotionController,
  schoolYearController,
} from "../../_api/controllers/scolarite.controller.ts";
import { capitalizeFirstLetter } from "../../_services/utils.jsx";
import { parentController } from "../../_api/controllers/parent.controller.ts";

const Student: React.FC = () => {
  const { isDarkMode, setIsDarkMode } = useOutletContext<OutletContextType>();
  const [notification, setNotification] = useState<any>(null); // { message, type }
  const [showEditDialog, setShowEditDialog] = useState<any>(false); // { message, type }
  const showNotification = (message: string, type = "success") => {
    setNotification({ message, type });
    setTimeout(() => setNotification(null), 3000);
  };

  //eleve data state

  const [currentId, setCurrentId] = useState<any>(null); // { message, type }
  const [formData, setFormData] = useState<{
    nom: string;
    postnom: string;
    prenom: string;
    genre: string;
    ville: string;
    commune: string;
    quartier: string;
    avenue: string;
    telephone: string;
    uid: string;
    date_naissance: string;
    lieu_naissance: string;
    parent_id: any;
  }>({
    // Informations personnelles

    nom: "",
    postnom: "",
    prenom: "",
    genre: "",
    ville: "",
    commune: "",
    quartier: "",
    avenue: "",
    telephone: "",
    uid: "",
    date_naissance: "",
    lieu_naissance: "",
    parent_id: "",
  });

  const handleChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  //filter for Student
  const [filtrerStudentBySy, setFiltrerStudentBySy] =
    useState("Selectionner année");
  const [filtrerStudentStatus, setfiltrerStudentStatus] = useState<any>("Tous");
  const [filtrerAffectationStatus, setfiltrerAffectationStatus] =
    useState<any>("Tous");
  const [searchQuery, setSearchQuery] = useState("");

  //dropdown filter
  const [isSchoolYearDropdownOpen, setIsSchoolYearDropdownOpen] =
    useState(false);
  const [isEleveStatusDropdownOpen, setIsEleveStatusDropdownOpen] =
    useState(false);
  const [isAffectationStatusDropdownOpen, setIsAffectationStatusDropdownOpen] =
    useState(false);

  //toggle dropDown function
  const toggleSchoolYearDropdown = () => {
    setIsSchoolYearDropdownOpen(!isSchoolYearDropdownOpen);
  };
  const toggleEleveStatusDropdown = () => {
    setIsEleveStatusDropdownOpen(!isEleveStatusDropdownOpen);
  };
  const toggleAffectationStatusDropdown = () => {
    setIsAffectationStatusDropdownOpen(!isAffectationStatusDropdownOpen);
  };

  //UseReducer for Desactivate, Activate
  //handleling delete & activate & desactivate items
  interface ActionState {
    actionSection: string;
    actionType: string;
    actionText: string;
    currentId: any;
  }

  interface Action {
    type: "DELETE" | "DESACTIVATE" | "CANCEL" | "ACTIVATE";
    payload: { actionText: string; actionSection: string; currentId: any };
  }
  const ACTION_TYPES = {
    DELETE: "DELETE",
    DESACTIVATE: "DESACTIVATE",
    ACTIVATE: "ACTIVATE",
    CANCEL: "CANCEL",
  };

  const INITIAL_STATE: ActionState = {
    actionSection: "",
    actionType: "",
    actionText: "",
    currentId: null,
  };

  const actionReducer = (state: ActionState, action: Action): ActionState => {
    switch (action.type) {
      case ACTION_TYPES.DELETE:
        return {
          ...state,
          actionType: "delete",
          actionSection: action.payload.actionSection,
          actionText: action.payload.actionText,
          currentId: action.payload.currentId,
        };

      case ACTION_TYPES.ACTIVATE:
        return {
          ...state,
          actionType: "activate",
          actionSection: action.payload.actionSection,
          actionText: action.payload.actionText,
          currentId: action.payload.currentId,
        };
      case ACTION_TYPES.DESACTIVATE:
        return {
          ...state,
          actionType: "desactivate",
          actionSection: action.payload.actionSection,
          actionText: action.payload.actionText,
          currentId: action.payload.currentId,
        };
      case ACTION_TYPES.CANCEL:
        return {
          actionSection: "",
          actionType: "",
          actionText: "",
          currentId: null,
        };

      default:
        return state;
    }
  };

  const [state_actions, dispatch] = React.useReducer(
    actionReducer,
    INITIAL_STATE
  );

  //fetch eleves
  const { data: eleveData } = useQuery({
    queryKey: ["students"],
    queryFn: studentControler.getAll,
  });
  //fetch promotion
  const { data: promotionsData } = useQuery({
    queryKey: ["promotions"],
    queryFn: promotionController.getAll,
  });

  //fetch anne scolaire
  const { data: schoolYearData } = useQuery({
    queryKey: ["schoolYears"],
    queryFn: schoolYearController.getAll,
  });

  //fetch classe
  const { data: classeData } = useQuery({
    queryKey: ["classes"],
    queryFn: classeController.getAll,
  });

  const { data: parentData } = useQuery({
    queryKey: ["parents"],
    queryFn: parentController.getAll,
  });

  const parentsDataArr = parentData?.data || [];
  const eleveDataArr = eleveData?.data || [];
  const promotionsDataArr = promotionsData?.data || [];
  const schoolYearDataArr = schoolYearData?.data || [];
  const classeDataArr = classeData?.data || [];

  const updatePromotionDataAr = promotionsDataArr.map((promo) => {
    let classeDesignation = "";
    let anneeDesignation = "";

    for (let classe of classeDataArr) {
      if (promo.classe_id === classe.id) {
        classeDesignation = classe.designation;
      }
    }

    for (let sY of schoolYearDataArr) {
      if (promo.annee_scolaire_id === sY.id) {
        anneeDesignation = sY.designation;
      }
    }
    return {
      ...promo,
      classeDesignation,
      anneeDesignation,
    };
  });

  //Eleve list affecter
  const updateEleveDataArr = eleveDataArr.map((eleve) => {
    let affected: boolean = false;
    let affectedClass = "";
    let anneeScolaire = "";
    let anneeScolaireId: any;
    let affectedClassId: any;
    // idEleve, selectedAnn, promAnn&promoElev,PromoCla
    for (let promo of updatePromotionDataAr) {
      if (
        filtrerStudentBySy === promo.anneeDesignation &&
        eleve.eleve_id === promo.eleve_id
      ) {
        affected = true;
        affectedClass = promo.classeDesignation;
        affectedClassId = promo.classe_id;
        anneeScolaire = promo.anneeDesignation;
        anneeScolaireId = promo.annee_scolaire_id;
      }
    }

    return {
      ...eleve,
      affected,
      classeDesignation: affectedClass,
      anneeDesignation: anneeScolaire,
      anneeScolaireId,
      classeId: affectedClassId,
    };
  });

  const filteredEleves = updateEleveDataArr.filter((eleve) => {
    const matchesQuery =
      eleve.nom.toLowerCase().includes(searchQuery.toLowerCase()) ||
      eleve.postnom.toLowerCase().includes(searchQuery.toLowerCase()) ||
      eleve.prenom.toLowerCase().includes(searchQuery.toLowerCase());

    const matchesStudentStatus =
      filtrerStudentStatus === "Tous" || filtrerStudentStatus == eleve.status;

    const matchesAffectationStatus =
      filtrerAffectationStatus === "Tous" ||
      filtrerAffectationStatus == eleve.affected;

    return matchesQuery && matchesStudentStatus && matchesAffectationStatus;
  });

  const assignedEleves = filteredEleves.filter((eleve) => {
    const matchesAffectationStatus = eleve.affected;
    return matchesAffectationStatus;
  });
  const unassignedEleves = filteredEleves.filter((eleve) => {
    const matchesAffectationStatus = !eleve.affected;
    return matchesAffectationStatus;
  });

  const archivedEleves = filteredEleves.filter((eleve) => {
    const matchesStudentStatus = !eleve.status;
    return matchesStudentStatus;
  });

  //statistic number
  let studentStats = {
    total: filteredEleves.length,
    assigned: assignedEleves.length,
    unassigned: unassignedEleves.length,
    archived: archivedEleves.length,
  };

  //get active school year
  const activeYear = schoolYearDataArr.filter((item) => item.status)[0]
    ?.designation;

  const activeYearId = schoolYearDataArr.filter((item) => item.status)[0]?.id;

  const [showAffectionModal, setShowAffectionModal] = useState(false);
  const [newPromotion, setNewPromotion] = useState<{
    classe_id: any;
    annee_scolaire_id: any;
    eleve_id: any;
  }>({
    classe_id: "",
    annee_scolaire_id: "",
    eleve_id: "",
  });

  // console.log("==============");
  // console.log(newPromotion);
  // console.log(activeYear);
  // console.log(activeYearId);

  // Fermeture des menus lors d'un clic à l'extérieur
  const schoolYearDropdownRef = React.useRef<HTMLDivElement>(null);
  const studentStatusDropdownRef = React.useRef<HTMLDivElement>(null);
  const affectationStatusDropdownRef = React.useRef<HTMLDivElement>(null);

  const queryClient = useQueryClient();

  const mutationCreatePromotion = useMutation({
    mutationFn: () =>
      promotionController.create({
        eleve_id: newPromotion.eleve_id,
        classe_id: newPromotion.classe_id,
        annee_scolaire_id: newPromotion.annee_scolaire_id,
      }),

    onSuccess: (data) => {
      console.log("==================");
      console.log(data);
      setShowAffectionModal(false);
      showNotification("Enregistré avec succès", "success");
      setNewPromotion({
        classe_id: "",
        annee_scolaire_id: "",
        eleve_id: "",
      });
      queryClient.invalidateQueries({ queryKey: ["eleves"] });
      queryClient.invalidateQueries({ queryKey: ["promotions"] });
    },

    onError: (err) => {
      showNotification("Une erreur est survenue, réessayer....", "error");
    },
  });

  const mutationDesactivateStudent = useMutation({
    mutationFn: () => studentControler.desactivate(state_actions.currentId),

    onSuccess: (data) => {
      console.log(data);
      showNotification("Désactivation effectuée avec succès", "success");
      dispatch({
        type: "CANCEL",
        payload: { actionText: "", currentId: null, actionSection: "" },
      });
      // setCurrentId(null);
      queryClient.invalidateQueries({ queryKey: ["students"] });
    },

    onError: (err) => {
      console.log(err);
      showNotification("Une erreur est survenue, réessayer....", "error");
    },
  });

  const mutationActivateStudent = useMutation({
    mutationFn: () => studentControler.activate(state_actions.currentId),

    onSuccess: (data) => {
      console.log(data);
      showNotification("Activation effectuée avec succès", "success");
      dispatch({
        type: "CANCEL",
        payload: { actionText: "", currentId: null, actionSection: "" },
      });
      // setCurrentId(null);
      queryClient.invalidateQueries({ queryKey: ["students"] });
    },

    onError: (err) => {
      console.log(err);
      showNotification("Une erreur est survenue, réessayer....", "error");
    },
  });

  const handleActivate = () => {
    if (
      state_actions.actionType === "activate" &&
      state_actions.actionSection === "student"
    ) {
      mutationActivateStudent.mutate();
    }
  };
  const handleDesactivate = () => {
    if (
      state_actions.actionType === "desactivate" &&
      state_actions.actionSection === "student"
    ) {
      mutationDesactivateStudent.mutate();
    }
  };

  const handleAffect = () => {
    if (!newPromotion.classe_id || !newPromotion.annee_scolaire_id)
      return showNotification(
        "Veuillez sélectionner la promotion et l'année scolaire",
        "erreur"
      );
    mutationCreatePromotion.mutate();
  };

  React.useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      //status button

      if (
        schoolYearDropdownRef.current &&
        !schoolYearDropdownRef.current.contains(event.target as Node)
      ) {
        setIsSchoolYearDropdownOpen(false);
      }
      if (
        studentStatusDropdownRef.current &&
        !studentStatusDropdownRef.current.contains(event.target as Node)
      ) {
        setIsEleveStatusDropdownOpen(false);
      }
      if (
        affectationStatusDropdownRef.current &&
        !affectationStatusDropdownRef.current.contains(event.target as Node)
      ) {
        setIsAffectationStatusDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Fonction pour exporter les données
  const exportData = () => {
    let data = filteredEleves.map((student) => ({
      Noms: ` ${student.nom} ${student.postnom} ${capitalizeFirstLetter(
        student.prenom
      )}`,
      Classe: student.classeDesignation || "-",
      AnneeScolaire: student.anneeDesignation || "-",
      Status:
        student.status === 1 ? "Active" : student.status === 0 && "Desactive",
      Affectation: student.affected
        ? "Affecte"
        : !student.affected && "Non affecte",
    }));

    // Create Excel-like content
    const headers = Object.keys(data[0]);
    const excelContent = [
      headers.join("\t"),
      ...data.map((row: any) =>
        headers.map((header) => row[header]).join("\t")
      ),
    ].join("\n");
    // Create and trigger download
    const blob = new Blob([excelContent], {
      type: "text/tab-separated-values;charset=utf-8;",
    });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `Attendance_${new Date().toISOString().split("T")[0]}.xls`;
    link.click();

    showNotification("Export Excel réussi");
  };

  const mutationUpdateStudent = useMutation({
    mutationFn: () =>
      studentControler.update(currentId, {
        nom: formData.nom,
        postnom: formData.postnom,
        prenom: formData.prenom,
        sexe: formData.genre,
        ville: formData.ville,
        commune: formData.commune,
        quartier: formData.quartier,
        avenue: formData.avenue,
        telephone: formData.telephone,
        uid: "12345678",
        date_naissance: formData.date_naissance,
        lieu_naissance: formData.lieu_naissance,
        parent_id: formData.parent_id,
      }),

    onSuccess: () => {
      setShowEditDialog(false);
      showNotification("Modification effectuée avec succès", "success");
      setCurrentId("");
      setFormData({
        nom: "",
        postnom: "",
        prenom: "",
        genre: "",
        ville: "",
        commune: "",
        quartier: "",
        avenue: "",
        telephone: "",
        uid: "",
        date_naissance: "",
        lieu_naissance: "",
        parent_id: "",
      });
      queryClient.invalidateQueries({ queryKey: ["students"] });
    },

    onError: () => {
      showNotification("Une erreur est survenue, réessayer....", "error");
    },
  });

  const handleUpdateStudent = () => {
    const {
      nom,
      postnom,
      prenom,
      genre,
      lieu_naissance,
      date_naissance,
      ville,
      commune,
      quartier,
      avenue,
      parent_id,
    } = formData;
    if (
      !nom.trim() ||
      !postnom.trim() ||
      !prenom.trim() ||
      !genre.trim() ||
      !lieu_naissance.trim() ||
      !date_naissance.trim() ||
      !ville.trim() ||
      !commune.trim() ||
      !quartier.trim() ||
      !avenue.trim() ||
      !parent_id
    ) {
      return showNotification(
        "Veuillez renseigner tous les champs obligatoires"
      );
    } else {
      mutationUpdateStudent.mutate();
    }
  };

  // This regular expression checks for:
  // 1. A "+" followed by a country code (e.g., +1, +44, etc.)
  // 2. Then, 10 digits for the phone number (or adjust the length to your requirements).
  const phoneNumberSchema = Yup.string().matches(
    /^\+(\d{1,3})\d{7,14}$/, // Example: +1 followed by 10-15 digits
    "Entrer l'indicatif de pays suivi d'un numéro valide"
  );

  // Example usage in a form:
  const validatePhoneNumber = async (phoneNumber: any) => {
    if (!!formData.telephone.trim()) {
      try {
        await phoneNumberSchema.validate(phoneNumber);
        console.log("Phone number is valid!");
      } catch (error: any) {
        console.error("Validation error:", error.message);
        return showNotification(error.message, "error");
      }
    }
  };

  return (
    <div className="space-y-6">
      <div
        className={`rounded-lg overflow-hidden border ${
          isDarkMode ? "border-gray-700" : "border-gray-300"
        }`}
      >
        <div className={`p-5 ${isDarkMode ? "bg-[#0D1117]" : "bg-white"}`}>
          {/* Stats Cards */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
            <div
              className={`p-4 rounded-lg ${
                isDarkMode ? "bg-[#161B22]" : "bg-gray-50"
              } border ${isDarkMode ? "border-gray-700" : "border-gray-200"}`}
            >
              <div className="flex items-center justify-between">
                <div>
                  <p
                    className={`text-sm ${
                      isDarkMode ? "text-gray-400" : "text-gray-600"
                    }`}
                  >
                    Total Élèves
                  </p>
                  <h3 className="text-2xl font-bold">{studentStats.total}</h3>
                </div>
                <div
                  className={`p-3 rounded-full ${
                    isDarkMode ? "bg-blue-900" : "bg-blue-100"
                  }`}
                >
                  <i
                    className={`fas fa-users ${
                      isDarkMode ? "text-blue-400" : "text-blue-600"
                    }`}
                  ></i>
                </div>
              </div>
            </div>
            <div
              className={`p-4 rounded-lg ${
                isDarkMode ? "bg-[#161B22]" : "bg-gray-50"
              } border ${isDarkMode ? "border-gray-700" : "border-gray-200"}`}
            >
              <div className="flex items-center justify-between">
                <div>
                  <p
                    className={`text-sm ${
                      isDarkMode ? "text-gray-400" : "text-gray-600"
                    }`}
                  >
                    Affectés
                  </p>
                  <h3 className="text-2xl font-bold">
                    {studentStats.assigned}
                  </h3>
                </div>
                <div
                  className={`p-3 rounded-full ${
                    isDarkMode ? "bg-green-900" : "bg-green-100"
                  }`}
                >
                  <i
                    className={`fas fa-check-circle ${
                      isDarkMode ? "text-green-400" : "text-green-600"
                    }`}
                  ></i>
                </div>
              </div>
            </div>
            <div
              className={`p-4 rounded-lg ${
                isDarkMode ? "bg-[#161B22]" : "bg-gray-50"
              } border ${isDarkMode ? "border-gray-700" : "border-gray-200"}`}
            >
              <div className="flex items-center justify-between">
                <div>
                  <p
                    className={`text-sm ${
                      isDarkMode ? "text-gray-400" : "text-gray-600"
                    }`}
                  >
                    Non Affectés
                  </p>
                  <h3 className="text-2xl font-bold">
                    {studentStats.unassigned}
                  </h3>
                </div>
                <div
                  className={`p-3 rounded-full ${
                    isDarkMode ? "bg-yellow-900" : "bg-yellow-100"
                  }`}
                >
                  <i
                    className={`fas fa-exclamation-circle ${
                      isDarkMode ? "text-yellow-400" : "text-yellow-600"
                    }`}
                  ></i>
                </div>
              </div>
            </div>
            <div
              className={`p-4 rounded-lg ${
                isDarkMode ? "bg-[#161B22]" : "bg-gray-50"
              } border ${isDarkMode ? "border-gray-700" : "border-gray-200"}`}
            >
              <div className="flex items-center justify-between">
                <div>
                  <p
                    className={`text-sm ${
                      isDarkMode ? "text-gray-400" : "text-gray-600"
                    }`}
                  >
                    Désactivés
                  </p>
                  <h3 className="text-2xl font-bold">
                    {studentStats.archived}
                  </h3>
                </div>
                <div
                  className={`p-3 rounded-full ${
                    isDarkMode ? "bg-gray-800" : "bg-gray-200"
                  }`}
                >
                  <i
                    className={`fas fa-archive ${
                      isDarkMode ? "text-gray-400" : "text-gray-600"
                    }`}
                  ></i>
                </div>
              </div>
            </div>
          </div>
          {/* Filters and Actions */}
          <div className="flex flex-wrap gap-4 mb-6">
            <div className="flex-grow relative">
              <div
                className={`absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-500`}
              >
                <i className="fas fa-search"></i>
              </div>
              <input
                type="text"
                placeholder="Rechercher un élève..."
                className={`w-full pl-10 pr-4 py-2 rounded-md text-sm ${
                  isDarkMode
                    ? "bg-[#161B22] border-gray-700"
                    : "bg-white border-gray-300"
                } border focus:outline-none focus:ring-2 focus:ring-blue-500`}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
            <div className="relative">
              <button
                onClick={toggleSchoolYearDropdown}
                className={`flex items-center px-4 py-2 rounded-md ${
                  isDarkMode
                    ? "bg-[#161B22] hover:bg-gray-700"
                    : "bg-white hover:bg-gray-100"
                } border ${
                  isDarkMode ? "border-gray-700" : "border-gray-300"
                } !rounded-button whitespace-nowrap`}
              >
                <span>{filtrerStudentBySy}</span>
                <i className="fas fa-chevron-down ml-2"></i>
              </button>
              {isSchoolYearDropdownOpen && (
                <div
                  className={`absolute top-full left-0 mt-1 w-40 rounded-md shadow-lg ${
                    isDarkMode ? "bg-[#161B22]" : "bg-white"
                  } border ${
                    isDarkMode ? "border-gray-700" : "border-gray-300"
                  } z-50`}
                  ref={schoolYearDropdownRef}
                >
                  <div className="py-1">
                    {schoolYearDataArr.map((year) => (
                      <button
                        key={year.id}
                        onClick={() => {
                          setFiltrerStudentBySy(year.designation);
                          setIsSchoolYearDropdownOpen(false);
                        }}
                        className={`block w-full text-left px-4 py-2 text-sm ${
                          isDarkMode
                            ? "hover:bg-gray-700 text-gray-200"
                            : "hover:bg-gray-100 text-gray-700"
                        } !rounded-button whitespace-nowrap`}
                      >
                        {year.designation}
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>
            <div className="relative">
              <button
                onClick={toggleEleveStatusDropdown}
                className={`flex items-center px-4 py-2 rounded-md ${
                  isDarkMode
                    ? "bg-[#161B22] hover:bg-gray-700"
                    : "bg-white hover:bg-gray-100"
                } border ${
                  isDarkMode ? "border-gray-700" : "border-gray-300"
                } !rounded-button whitespace-nowrap`}
              >
                <span>
                  Status:{" "}
                  {filtrerStudentStatus == 1
                    ? "Active"
                    : filtrerStudentStatus == 0
                    ? "Désactivé"
                    : "Tous"}
                </span>
                <i className="fas fa-chevron-down ml-2"></i>
              </button>
              {isEleveStatusDropdownOpen && (
                <div
                  className={`absolute top-full left-0 mt-1 w-40 rounded-md shadow-lg ${
                    isDarkMode ? "bg-[#161B22]" : "bg-white"
                  } border ${
                    isDarkMode ? "border-gray-700" : "border-gray-300"
                  } z-50`}
                  ref={studentStatusDropdownRef}
                >
                  <div className="py-1">
                    {[
                      { id: 0, designation: "Tous", status: "Tous" },
                      { id: 1, designation: "Active", status: 1 },
                      { id: 2, designation: "Désactivé", status: 0 },
                    ].map((status) => (
                      <button
                        key={status.id}
                        onClick={() => {
                          setfiltrerStudentStatus(status.status);
                          setIsEleveStatusDropdownOpen(false);
                        }}
                        className={`block w-full text-left px-4 py-2 text-sm ${
                          isDarkMode
                            ? "hover:bg-gray-700 text-gray-200"
                            : "hover:bg-gray-100 text-gray-700"
                        } !rounded-button whitespace-nowrap`}
                      >
                        {status.designation}
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>
            <div className="relative">
              <button
                onClick={toggleAffectationStatusDropdown}
                className={`flex items-center px-4 py-2 rounded-md ${
                  isDarkMode
                    ? "bg-[#161B22] hover:bg-gray-700"
                    : "bg-white hover:bg-gray-100"
                } border ${
                  isDarkMode ? "border-gray-700" : "border-gray-300"
                } !rounded-button whitespace-nowrap`}
              >
                <span>
                  Affectation:{" "}
                  {filtrerAffectationStatus == 1
                    ? "Affecté"
                    : filtrerAffectationStatus == 0
                    ? "Non affecté"
                    : "Tous"}
                </span>
                <i className="fas fa-chevron-down ml-2"></i>
              </button>
              {isAffectationStatusDropdownOpen && (
                <div
                  className={`absolute top-full left-0 mt-1 w-40 rounded-md shadow-lg ${
                    isDarkMode ? "bg-[#161B22]" : "bg-white"
                  } border ${
                    isDarkMode ? "border-gray-700" : "border-gray-300"
                  } z-50`}
                  ref={affectationStatusDropdownRef}
                >
                  <div className="py-1">
                    {[
                      { id: 0, designation: "Tous", status: "Tous" },
                      { id: 1, designation: "Affecté", status: 1 },
                      { id: 2, designation: "Non ffecté", status: 0 },
                    ].map((item) => (
                      <button
                        key={item.id}
                        onClick={() => {
                          setfiltrerAffectationStatus(item.status);
                          setIsAffectationStatusDropdownOpen(false);
                        }}
                        className={`block w-full text-left px-4 py-2 text-sm ${
                          isDarkMode
                            ? "hover:bg-gray-700 text-gray-200"
                            : "hover:bg-gray-100 text-gray-700"
                        } !rounded-button whitespace-nowrap`}
                      >
                        {item.designation}
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>
            {/* <div className="relative">
              <button
                id="statusFilterBtn"
                onClick={() =>
                  setStudentFilter((prev) => ({
                    ...prev,
                    isStatusDropdownOpen: !prev.isStatusDropdownOpen,
                  }))
                }
                className={`flex items-center px-4 py-2 rounded-md ${
                  isDarkMode
                    ? "bg-[#161B22] hover:bg-gray-700"
                    : "bg-white hover:bg-gray-100"
                } border ${
                  isDarkMode ? "border-gray-700" : "border-gray-300"
                } !rounded-button whitespace-nowrap`}
              >
                <span>
                  Statut:{" "}
                  {studentFilter.status === "all"
                    ? "Tous"
                    : studentFilter.status === "assigned"
                    ? "Affectés"
                    : studentFilter.status === "unassigned"
                    ? "Non affectés"
                    : "Archivés"}
                </span>
                <i className="fas fa-chevron-down ml-2"></i>
              </button>
              {studentFilter.isStatusDropdownOpen && (
                <div
                  className={`absolute top-full left-0 mt-1 w-40 rounded-md shadow-lg ${
                    isDarkMode ? "bg-[#161B22]" : "bg-white"
                  } border ${
                    isDarkMode ? "border-gray-700" : "border-gray-300"
                  } z-50`}
                >
                  <div className="py-1">
                    {[
                      { value: "all", label: "Tous" },
                      { value: "assigned", label: "Affectés" },
                      { value: "unassigned", label: "Non affectés" },
                      { value: "archived", label: "Archivés" },
                    ].map((status) => (
                      <button
                        key={status.value}
                        onClick={() => {
                          setStudentFilter((prev) => ({
                            ...prev,
                            status: status.value,
                            isStatusDropdownOpen: false,
                          }));
                        }}
                        className={`block w-full text-left px-4 py-2 text-sm ${
                          isDarkMode
                            ? "hover:bg-gray-700 text-gray-200"
                            : "hover:bg-gray-100 text-gray-700"
                        } !rounded-button whitespace-nowrap`}
                      >
                        {status.label}
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div> */}
            <Link
              to={"/eleves/nouveau"}
              className={`px-4 py-2 rounded-md ${
                isDarkMode
                  ? "bg-green-600 hover:bg-green-700"
                  : "bg-green-500 hover:bg-green-600"
              } text-white !rounded-button whitespace-nowrap inline-flex items-center`}
            >
              <i className="fas fa-plus mr-2"></i>Ajouter un élève
            </Link>

            <button
              onClick={exportData}
              className={`px-4 py-2 rounded-md ${
                isDarkMode
                  ? "bg-blue-600 hover:bg-blue-700"
                  : "bg-blue-500 hover:bg-blue-600"
              } text-white !rounded-button whitespace-nowrap`}
            >
              <i className="fas fa-file-import mr-2"></i>Exporter
            </button>
          </div>
          {/* Students Table */}
          <div
            className={`rounded-lg overflow-hidden border ${
              isDarkMode ? "border-gray-700" : "border-gray-300"
            }`}
          >
            <table className="min-w-full divide-y divide-gray-700">
              <thead
                className={`${isDarkMode ? "bg-[#161B22]" : "bg-gray-50"}`}
              >
                <tr>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                  >
                    Nom & Prénom
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                  >
                    Classe
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-center text-xs font-medium uppercase tracking-wider"
                  >
                    Année Scolaire
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-center text-xs font-medium uppercase tracking-wider"
                  >
                    Statut
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-center text-xs font-medium uppercase tracking-wider"
                  >
                    Affectation
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-center text-xs font-medium uppercase tracking-wider"
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody
                className={`${
                  isDarkMode ? "bg-[#0D1117]" : "bg-white"
                } divide-y ${
                  isDarkMode ? "divide-gray-700" : "divide-gray-200"
                }`}
              >
                {filteredEleves.map((item, index) => {
                  return (
                    <tr>
                      <td key={index} className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center">
                          <div className="flex-shrink-0 h-10 w-10">
                            <div
                              className={`h-10 w-10 rounded-full flex items-center justify-center ${
                                isDarkMode ? "bg-gray-700" : "bg-gray-200"
                              }`}
                            >
                              <i className="fas fa-user"></i>
                            </div>
                          </div>
                          <div className="ml-4">
                            <span
                              className={`px-0 inline-flex text-xs leading-5 font-semibold rounded-full ${
                                isDarkMode ? "text-gray-200" : "text-gray-700"
                              }`}
                            >
                              {capitalizeFirstLetter(item.nom)}{" "}
                              {capitalizeFirstLetter(item.postnom)}{" "}
                              {capitalizeFirstLetter(item.prenom)}
                            </span>{" "}
                            <div
                              className={`text-sm ${
                                isDarkMode ? "text-gray-400" : "text-gray-500"
                              }`}
                            >
                              ID: STD-00{index + 1}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        {!item.classeDesignation ? "-" : item.classeDesignation}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-center">
                        {!item.anneeDesignation ? "-" : item.anneeDesignation}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-center">
                        <span
                          className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                            item.status
                              ? "bg-green-100 text-green-800"
                              : "bg-yellow-100 text-yellow-800"
                          }`}
                        >
                          {item.status ? "active" : "Désactivé"}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-center">
                        <span
                          className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                            item.affected
                              ? "bg-green-100 text-green-800"
                              : "bg-yellow-100 text-yellow-800"
                          }`}
                        >
                          {item.affected ? "affecté" : "Non Affecté"}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-center">
                        <div className="flex justify-center space-x-3">
                          <button
                            onClick={() => {
                              setCurrentId(item.eleve_id);
                              setFormData({
                                nom: item.nom,
                                postnom: item.postnom,
                                prenom: item.prenom,
                                genre: item.sexe,
                                ville: item.ville,
                                commune: item.commune,
                                quartier: item.quartier,
                                avenue: item.avenue,
                                telephone: item.telephone,
                                uid: item.uid,
                                date_naissance: item.date_naissance,
                                lieu_naissance: item.lieu_naissance,
                                parent_id: item.parent_id,
                              });
                              setShowEditDialog(true);
                            }}
                            className="text-green-500 hover:text-green-700 cursor-pointer !rounded-button whitespace-nowrap"
                          >
                            <i className="fas fa-edit"></i>
                          </button>

                          <button
                            onClick={() => {
                              item.status
                                ? dispatch({
                                    type: "DESACTIVATE",
                                    payload: {
                                      actionText:
                                        "Êtes-vous sûr de vouloir désactiver cet élève?",
                                      currentId: item.eleve_id,
                                      actionSection: "student",
                                    },
                                  })
                                : dispatch({
                                    type: "ACTIVATE",
                                    payload: {
                                      actionText:
                                        "Êtes-vous sûr de vouloir Activer cet élève?",
                                      currentId: item.eleve_id,
                                      actionSection: "student",
                                    },
                                  });
                            }}
                            className={`${
                              item.status
                                ? "text-green-500 hover:text-green-700"
                                : "text-gray-500 hover:text-green-700"
                            } cursor-pointer !rounded-button whitespace-nowrap`}
                          >
                            <i className="fa-solid fa-circle-check"></i>
                          </button>
                          <button
                            disabled={
                              filtrerStudentBySy === "Selectionner année" ||
                              (item.affected &&
                                filtrerStudentBySy !== "Selectionner année")
                            }
                            onClick={() => {
                              setNewPromotion({
                                ...newPromotion,
                                eleve_id: item.eleve_id,
                              });
                              setShowAffectionModal(true);
                            }}
                            className={`${
                              filtrerStudentBySy === "Selectionner année" ||
                              (item.affected &&
                                filtrerStudentBySy !== "Selectionner année")
                                ? "text-gray-500 cursor-not-allowed"
                                : "text-yellow-500 hover:text-yellow-700 cursor-pointer "
                            } !rounded-button whitespace-nowrap`}
                            title="Affecter"
                          >
                            <i className="fas fa-archive"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {/* Pagination */}
          <div className="mt-4 flex items-center justify-end">
            <div
              className={`text-sm ${
                isDarkMode ? "text-gray-400" : "text-gray-500"
              }`}
            >
              Affichage de {studentStats.total} élèves
            </div>
          </div>
        </div>
      </div>

      {showAffectionModal && (
        <div
          id="addTerminalModal"
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
        >
          <div
            className={`${
              isDarkMode ? "bg-[#1c2128]" : "bg-white"
            } rounded-lg shadow-xl w-full max-w-lg mx-4`}
          >
            <div
              className={`px-6 py-4 border-b ${
                isDarkMode ? "border-gray-700" : "border-gray-200"
              } flex justify-between items-center`}
            >
              <h3 className="text-xl font-medium">Affectation</h3>
              <button
                id="closeTerminalModalBtn"
                className="text-gray-500 hover:text-gray-700"
                onClick={() => {
                  setShowAffectionModal(false);
                }}
              >
                <i className="fas fa-times"></i>
              </button>
            </div>
            <div className="px-6 py-4">
              <div className="mb-4">
                <label
                  className={`block text-sm font-medium mb-2 ${
                    isDarkMode ? "text-gray-300" : "text-gray-700"
                  }`}
                >
                  Nouvelle Promotion *
                </label>
                <select
                  onChange={(e) => {
                    setNewPromotion((prev) => ({
                      ...prev,
                      classe_id: e.target.value,
                    }));
                  }}
                  className={`w-full px-3 py-1 rounded-md border ${
                    isDarkMode
                      ? "bg-[#161B22] border-gray-700 text-white"
                      : "bg-white border-gray-300"
                  } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                  required
                >
                  <option value="">Sélectionner une classe</option>
                  {classeDataArr.map((item) => (
                    <option value={item.id}>
                      {capitalizeFirstLetter(item.designation)}
                    </option>
                  ))}
                </select>
              </div>
              <div className="mb-4">
                <label
                  className={`block text-sm font-medium mb-2 ${
                    isDarkMode ? "text-gray-300" : "text-gray-700"
                  }`}
                >
                  Année scolaire *
                </label>
                <select
                  onChange={(e) => {
                    setNewPromotion((prev) => ({
                      ...prev,
                      annee_scolaire_id: e.target.value,
                    }));
                  }}
                  className={`w-full px-3 py-1 rounded-md border ${
                    isDarkMode
                      ? "bg-[#161B22] border-gray-700 text-white"
                      : "bg-white border-gray-300"
                  } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                  required
                >
                  <option value="">Selectionner année scolaire</option>
                  <option value={activeYearId}>{activeYear}</option>
                </select>
              </div>
            </div>
            <div
              className={`px-6 py-4 border-t ${
                isDarkMode ? "border-gray-700" : "border-gray-200"
              } flex justify-center space-x-3`}
            >
              <button
                disabled={mutationCreatePromotion.isPending}
                onClick={() => {
                  setShowAffectionModal(false);
                }}
                className={`px-4 py-2 rounded-md ${
                  isDarkMode
                    ? "bg-gray-700 hover:bg-gray-600"
                    : "bg-gray-200 hover:bg-gray-300"
                } !rounded-button whitespace-nowrap ${
                  mutationCreatePromotion.isPending ? "cursor-not-allowed" : ""
                }`}
              >
                Annuler
              </button>

              <button
                disabled={mutationCreatePromotion.isPending}
                onClick={() => {
                  handleAffect();
                }}
                className={`px-4 py-2 rounded-md ${
                  isDarkMode
                    ? "bg-blue-600 hover:bg-blue-700"
                    : "bg-blue-500 hover:bg-blue-600"
                } text-white !rounded-button whitespace-nowrap  ${
                  mutationCreatePromotion.isPending ? "cursor-not-allowed" : ""
                }`}
              >
                {mutationCreatePromotion.isPending
                  ? "Affectaion en cours..."
                  : "Affecter"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Activate dialog */}
      {state_actions.actionType === "activate" && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div
            className={`${
              isDarkMode ? "bg-[#1c2128]" : "bg-white"
            } rounded-lg shadow-xl w-full max-w-md mx-4 p-6`}
          >
            <div className="text-xl font-medium mb-4">
              Confirmer l'activation
            </div>
            <p
              className={`${
                isDarkMode ? "text-gray-300" : "text-gray-600"
              } mb-6`}
            >
              {state_actions.actionText}
            </p>
            <div className="flex justify-end space-x-3">
              <button
                disabled={mutationActivateStudent.isPending}
                onClick={() =>
                  dispatch({
                    type: "CANCEL",
                    payload: {
                      actionText: "",
                      currentId: "",
                      actionSection: "",
                    },
                  })
                }
                className={`px-4 py-2 rounded-md ${
                  isDarkMode
                    ? "bg-gray-700 hover:bg-gray-600"
                    : "bg-gray-200 hover:bg-gray-300"
                } !rounded-button whitespace-nowrap ${
                  mutationActivateStudent.isPending ? "cursor-not-allowed" : ""
                }`}
              >
                Annuler
              </button>
              <button
                disabled={mutationActivateStudent.isPending}
                onClick={handleActivate}
                className={`px-4 py-2 rounded-md bg-blue-500 hover:bg-blue-600 text-white !rounded-button whitespace-nowrap ${
                  mutationActivateStudent.isPending ? "cursor-not-allowed" : ""
                }`}
              >
                {mutationActivateStudent.isPending
                  ? "Activation en cours..."
                  : "Confirmer l'activation"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Desactivate dialog */}
      {state_actions.actionType === "desactivate" && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div
            className={`${
              isDarkMode ? "bg-[#1c2128]" : "bg-white"
            } rounded-lg shadow-xl w-full max-w-md mx-4 p-6`}
          >
            <div className="text-xl font-medium mb-4">
              Confirmer la désactivation
            </div>
            <p
              className={`${
                isDarkMode ? "text-gray-300" : "text-gray-600"
              } mb-6`}
            >
              {state_actions.actionText}
            </p>
            <div className="flex justify-end space-x-3">
              <button
                disabled={mutationDesactivateStudent.isPending}
                onClick={() =>
                  dispatch({
                    type: "CANCEL",
                    payload: {
                      actionText: "",
                      currentId: "",
                      actionSection: "",
                    },
                  })
                }
                className={`px-4 py-2 rounded-md ${
                  isDarkMode
                    ? "bg-gray-700 hover:bg-gray-600"
                    : "bg-gray-200 hover:bg-gray-300"
                } !rounded-button whitespace-nowrap ${
                  mutationDesactivateStudent.isPending
                    ? "cursor-not-allowed"
                    : ""
                }`}
              >
                Annuler
              </button>
              <button
                disabled={mutationDesactivateStudent.isPending}
                onClick={handleDesactivate}
                className={`px-4 py-2 rounded-md bg-red-500 hover:bg-red-600 text-white !rounded-button whitespace-nowrap ${
                  mutationDesactivateStudent.isPending
                    ? "cursor-not-allowed"
                    : ""
                }`}
              >
                {mutationDesactivateStudent.isPending
                  ? "Activation en cours..."
                  : "Confirmer la désactivation"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Edit student Modal */}
      {showEditDialog && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div
            className={`${
              isDarkMode ? "bg-[#1c2128]" : "bg-white"
            } rounded-lg shadow-xl w-full max-w-[70%] p-6 mx-4`}
          >
            {/* Header */}
            <div
              className={`px-6 py-4 border-b ${
                isDarkMode ? "border-gray-700" : "border-gray-200"
              } flex justify-between items-center`}
            >
              <h3 className="text-xl font-medium">Modifier Elève</h3>
              <button
                onClick={() => {
                  setShowEditDialog(false);
                }}
                className="text-gray-500 hover:text-gray-700"
              >
                <i className="fas fa-times"></i>
              </button>
            </div>

            {/* Form */}
            <>
              <div className="flex justify-between items-center mb-4">
                <h3
                  className={`text-lg font-medium  ${
                    isDarkMode ? "text-gray-400" : "text-gray-600"
                  }`}
                >
                  {/* Contact {index + 1} */}
                  Données
                  <span className="ml-2 text-sm text-red-500">
                    (Principales)
                  </span>
                </h3>

                {/* {index > 0 && (
                          <button
                            type="button"
                            onClick={() => removeContact(index)}
                            className="text-red-600 hover:text-red-800 !rounded-button whitespace-nowrap"
                          >
                            <i className="fas fa-trash-alt"></i>
                          </button>
                        )} */}
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-4">
                <div>
                  <label
                    htmlFor={`nom`}
                    className={`block text-sm font-medium ${
                      isDarkMode ? "text-gray-400" : "text-600"
                    } `}
                  >
                    Nom <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id={`nom`}
                    name="nom"
                    required
                    value={formData.nom}
                    onChange={handleChange}
                    className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                      isDarkMode
                        ? "bg-[#0D1117] border-gray-700"
                        : "bg-gray-50 border-gray-200"
                    }`}
                  />
                </div>
                <div>
                  <label
                    htmlFor={`postnom`}
                    className={`block text-sm font-medium ${
                      isDarkMode ? "text-gray-400" : "text-600"
                    } `}
                  >
                    Post-Nom <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id={`postnom`}
                    name="postnom"
                    required
                    value={formData.postnom}
                    onChange={handleChange}
                    className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                      isDarkMode
                        ? "bg-[#0D1117] border-gray-700"
                        : "bg-gray-50 border-gray-200"
                    }`}
                  />
                </div>
                <div>
                  <label
                    htmlFor={`postnom`}
                    className={`block text-sm font-medium ${
                      isDarkMode ? "text-gray-400" : "text-600"
                    } `}
                  >
                    Prénom <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id={`prenom`}
                    name="prenom"
                    required
                    value={formData.prenom}
                    onChange={handleChange}
                    className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                      isDarkMode
                        ? "bg-[#0D1117] border-gray-700"
                        : "bg-gray-50 border-gray-200"
                    }`}
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-4">
                <div>
                  <label
                    htmlFor={`genre`}
                    className={`block text-sm font-medium ${
                      isDarkMode ? "text-gray-400" : "text-600"
                    } `}
                  >
                    Genre <span className="text-red-500">*</span>
                  </label>
                  <select
                    id={`genre`}
                    name="genre"
                    required
                    value={formData.genre}
                    onChange={handleChange}
                    className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                      isDarkMode
                        ? "bg-[#0D1117] border-gray-700"
                        : "bg-gray-50 border-gray-200"
                    }`}
                  >
                    <option value="">Sélectionner</option>
                    <option value="M">Masculin</option>
                    <option value="F">Feminin</option>
                  </select>
                </div>

                <div>
                  <label
                    htmlFor={`prenom`}
                    className={`block text-sm font-medium ${
                      isDarkMode ? "text-gray-400" : "text-600"
                    } `}
                  >
                    Lieux de naissance <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id={`lieuxNaissance`}
                    name="lieuxNaissance"
                    required
                    value={formData.lieu_naissance}
                    onChange={handleChange}
                    className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                      isDarkMode
                        ? "bg-[#0D1117] border-gray-700"
                        : "bg-gray-50 border-gray-200"
                    }`}
                  />
                </div>
                <div>
                  <label
                    htmlFor={`dateNaissance`}
                    className={`block text-sm font-medium ${
                      isDarkMode ? "text-gray-400" : "text-600"
                    } `}
                  >
                    Date de Naissance <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="date"
                    id={`dateNaissance`}
                    name="dateNaissance"
                    required
                    value={formData.date_naissance}
                    onChange={handleChange}
                    className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                      isDarkMode
                        ? "bg-[#0D1117] border-gray-700"
                        : "bg-gray-50 border-gray-200"
                    }`}
                  />
                </div>
              </div>

              <div className="space-y-6">
                <div>
                  <h3
                    className={`text-lg font-medium  ${
                      isDarkMode ? "text-gray-400" : "text-gray-600"
                    }`}
                  >
                    Adresse principale & Profession
                  </h3>
                  <div className="mt-4 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                    <div className="sm:col-span-6">
                      <label
                        htmlFor="avenue"
                        className={`block text-sm font-medium ${
                          isDarkMode ? "text-gray-400" : "text-600"
                        } `}
                      >
                        Avenue <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        name="avenue"
                        id="avenue"
                        required
                        value={formData.avenue}
                        onChange={handleChange}
                        className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                          isDarkMode
                            ? "bg-[#0D1117] border-gray-700"
                            : "bg-gray-50 border-gray-200"
                        }`}
                      />
                    </div>
                    <div className="sm:col-span-2">
                      <label
                        htmlFor="quartier"
                        className={`block text-sm font-medium ${
                          isDarkMode ? "text-gray-400" : "text-600"
                        } `}
                      >
                        Quartier <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        name="quartier"
                        id="quartier"
                        required
                        value={formData.quartier}
                        onChange={handleChange}
                        className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                          isDarkMode
                            ? "bg-[#0D1117] border-gray-700"
                            : "bg-gray-50 border-gray-200"
                        }`}
                      />
                    </div>
                    <div className="sm:col-span-4">
                      <label
                        htmlFor="commune"
                        className={`block text-sm font-medium ${
                          isDarkMode ? "text-gray-400" : "text-600"
                        } `}
                      >
                        Commune <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        name="commune"
                        id="commune"
                        required
                        value={formData.commune}
                        onChange={handleChange}
                        className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                          isDarkMode
                            ? "bg-[#0D1117] border-gray-700"
                            : "bg-gray-50 border-gray-200"
                        }`}
                      />
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label
                      htmlFor="ville"
                      className={`block text-sm font-medium ${
                        isDarkMode ? "text-gray-400" : "text-600"
                      } `}
                    >
                      Ville <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="ville"
                      id="ville"
                      value={formData.ville}
                      onChange={handleChange}
                      className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                        isDarkMode
                          ? "bg-[#0D1117] border-gray-700"
                          : "bg-gray-50 border-gray-200"
                      }`}
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="telephone"
                      className={`block text-sm font-medium ${
                        isDarkMode ? "text-gray-400" : "text-600"
                      } `}
                    >
                      Téléphone
                    </label>
                    <input
                      type="tel"
                      name="telephone"
                      id="telephone"
                      required
                      value={formData.telephone}
                      onChange={handleChange}
                      className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                        isDarkMode
                          ? "bg-[#0D1117] border-gray-700"
                          : "bg-gray-50 border-gray-200"
                      }`}
                    />
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
                <div>
                  <label
                    htmlFor={`email`}
                    className={`block text-sm font-medium ${
                      isDarkMode ? "text-gray-400" : "text-600"
                    } `}
                  >
                    Parent
                  </label>
                  <select
                    name="idParent"
                    id="idParent"
                    required
                    value={formData.parent_id}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        parent_id: e.target.value,
                      }))
                    }
                    className={`mt-1 block w-full h-12 border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                      isDarkMode
                        ? "bg-[#0D1117] border-gray-700"
                        : "bg-gray-50 border-gray-200"
                    }`}
                  >
                    <option value="">Sélectionner parent</option>
                    {parentsDataArr.map((item) => (
                      <option key={item.parent_id} value={item.parent_id}>
                        {item.nom.toUpperCase()} {item.postnom.toUpperCase()}{" "}
                        {item.prenom.toUpperCase()}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </>

            {/* Footer */}
            <div
              className={`px-6 py-4 border-t ${
                isDarkMode ? "border-gray-700" : "border-gray-200"
              } flex justify-end space-x-3`}
            >
              <button
                disabled={mutationUpdateStudent.isPending}
                onClick={() => {
                  setShowEditDialog(false);
                }}
                className={`px-4 py-2 rounded-md ${
                  isDarkMode
                    ? "bg-gray-700 hover:bg-gray-600"
                    : "bg-gray-200 hover:bg-gray-300"
                } !rounded-button whitespace-nowrap ${
                  mutationUpdateStudent.isPending ? "cursor-not-allowed" : ""
                }`}
              >
                Annuler
              </button>

              <button
                disabled={mutationUpdateStudent.isPending}
                onClick={() => {
                  // Handle save logic here
                  handleUpdateStudent();
                }}
                className={`px-4 py-2 rounded-md ${
                  isDarkMode
                    ? "bg-blue-600 hover:bg-blue-700"
                    : "bg-blue-500 hover:bg-blue-600"
                } text-white !rounded-button whitespace-nowrap  ${
                  mutationUpdateStudent.isPending ? "cursor-not-allowed" : ""
                }`}
              >
                {mutationUpdateStudent.isPending ? (
                  <span className="flex items-center justify-center">
                    <i className="fas fa-spinner fa-spin mr-2"></i>
                    Chargement...
                  </span>
                ) : (
                  "Mettre à jour"
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===== NOTIFICATION ===== */}
      {notification && (
        <div
          className={`fixed bottom-4 right-4 px-6 py-3 rounded-lg text-white shadow-lg transition-all duration-500 ${
            notification.type === "success" ? "bg-green-500" : "bg-red-500"
          }`}
        >
          {notification.message}
        </div>
      )}
    </div>
  );
};

export default Student;
